import { render } from "./ProductCardModal.vue?vue&type=template&id=6fbf03b8"
import script from "./ProductCardModal.vue?vue&type=script&lang=js"
export * from "./ProductCardModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__